import { gql } from 'graphql-request'
import { mainApi } from '@client/client'
import { ProfitFilterParams } from '@models/Profit/ProfitFilterParams'

export const profitApi = mainApi.injectEndpoints({
  overrideExisting: false,
  endpoints: builder => ({
    profit: builder.query<{ profitUsd: number }, ProfitFilterParams>({
      query: ({ profitType, botMarketType }) => ({
        document: gql`
          query Profit(
            $profitType: ProfitType!
            $botMarketType: BotMarketType
          ) {
            profit(profitType: $profitType, botMarketType: $botMarketType) {
              profitUsd
            }
          }
        `,
        variables: { profitType, botMarketType },
      }),
      transformResponse(res: { profit: { profitUsd: number } }) {
        const { profit } = res
        return profit
      },
      providesTags: (result, error, arg) => [{ type: 'Profit', ...arg }],
    }),
  }),
})

export const { useProfitQuery } = profitApi
